module.exports = __webpack_public_path__ + "static/media/0.bcfacb51.svg";